<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <b-row></b-row>
        </b-card-header>

        <b-col cols="12">
            <b-row class="d-flex align-items-center justify-content-md-between">
                <b-col cols="12" md="8" class="d-md-flex">
                    <base-input
                        v-model="searchQuery"
                        v-on:input="debouncedHandler"
                        prepend-icon="fas fa-search"
                        placeholder="Search"
                    >
                    </base-input>
                </b-col>
                <!-- <b-col cols="12" md="4" class="d-flex justify-content-center d-md-block">
                    <b-button variant="outline-primary" class="float-md-right mx-2" disabled>
                        <b-icon icon="filter"></b-icon>
                        Filter
                    </b-button>
                </b-col> -->
            </b-row>
        </b-col>

        <!-- TABLE LIST -->
        <div class="table-listings">
            <el-table 
                ref="multipleTable"
                v-loading="isTableLoading"
                :data="tableData"
                style="width: 100%;"
            >
                <el-table-column
                    type="selection"
                    width="35"
                    class-name="px-2"
                ></el-table-column>

                <el-table-column
                    label="ID"
                    prop="credit_report_id"
                    width="80"
                >
                </el-table-column>

                <el-table-column
                    label="Customer Name/IC/ID"
                    prop="credit_report_cust_name"
                    width="280"
                >
                    <template slot="header" slot-scope="scope">
                        <span class="text-break">{{ scope.column.label }}</span>
                    </template>
                    <template slot-scope="scope">
                        <p class="top-line text-break">{{ scope.row.credit_report_cust_name | formatUserName(25) }}</p>
                        <p class="bottom-line">{{ scope.row.credit_report_cust_ic }}</p>
                        <p class="bottom-line">{{ scope.row.credit_report_cust_id }}</p>
                    </template>
                </el-table-column>
							
								<el-table-column
                    prop="name"
                    min-width="200"
                >
										<template slot="header">
												<div class="d-inline-block">
														<div>Platform</div>
														<div><small>Request Datetime</small></div>
												</div>
										</template>
                    <template slot-scope="scope">
                         <p class="mb-0 top-line">
                          {{
                            scope.row.credit_report_platform === 'CTOS'
                              ? 'Comprehensive Report'
                              : scope.row.credit_report_platform === 'CBM'
                                ? 'Premium Report'
                                : scope.row.credit_report_platform
                          }}
                        </p>
                        <p class="mb-0 bottom-line">{{ scope.row.credit_report_request_datetime | dateTimeFormatString }}</p>
                    </template>
                </el-table-column>

                <!-- <el-table-column
                    label="Prescreening Analysis Report"
                    min-width="170"
                    >
                    <template v-slot="{row}">
                        <a href="javascript:void(0)" 
                            @click="$refs.preview_modal.preview( row.credit_report_fintscore_unsigned_url)"
                            class="font-weight-bold"
                            v-if="!_gHlp.isEmpty(row.credit_report_fintscore_unsigned_url)"
                        >View</a>
                        <span v-else>-</span>
                    </template>
                </el-table-column> -->
                
								<el-table-column
                    prop="credit_report_pdf_unsigned_url"
                    label="Credit Report"
                    min-width="170">
                    <template v-slot="{row}">
                        <a href="javascript:void(0)" 
                            @click="$refs.preview_modal.preview( row.credit_report_pdf_unsigned_url)"
                            class="font-weight-bold"
                            v-if="!_gHlp.isEmpty(row.credit_report_pdf_unsigned_url)"
                        >View</a>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                
								<el-table-column
                    prop="credit_report_consent_unsigned_url"
                    label="Consent Form"
                    min-width="170">    
                    <template v-slot="{row}">
                        <a href="javascript:void(0)" 
                            @click="$refs.preview_modal.preview(row.credit_report_consent_unsigned_url)"
                            class="font-weight-bold" 
                            v-if="!_gHlp.isEmpty(row.credit_report_consent_unsigned_url)"
                        >View</a>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                
								<el-table-column
                    prop="credit_report_ic_front_unsigned_url"
                    label="Front NRIC"
                    min-width="170">    
                    <template v-slot="{row}">
                        <a href="javascript:void(0)" 
                            @click="$refs.preview_modal.preview(row.credit_report_ic_front_unsigned_url)"
                            class="font-weight-bold" 
                            v-if="!_gHlp.isEmpty(row.credit_report_ic_front_unsigned_url)"
                        >View</a>
                        <span v-else>-</span>
                    </template>
                </el-table-column>

                <el-table-column
                    prop="credit_report_ic_back_unsigned_url"
                    label="Back NRIC"
                    min-width="170">    
                    <template v-slot="{row}">
                        <a href="javascript:void(0)" 
                            @click="$refs.preview_modal.preview(row.credit_report_ic_back_unsigned_url)"
                            class="font-weight-bold" 
                            v-if="!_gHlp.isEmpty(row.credit_report_ic_back_unsigned_url)"
                        >View</a>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-md-between flex-wrap"
        >
            <div class="d-flex align-items-center mb-3">
                <p class="card-category mb-0 text-secondary">
                    Showing {{ from + 1 }} to {{ to }} of {{ pagination.total }} entries
        
                    <span v-if="selectedRows.length">
                        &nbsp; &nbsp; {{selectedRows.length}} rows selected
                    </span>
                </p>

                <span class="mb-0 ml-4">Rows:</span>

                <el-select
                    class="select-primary pagination-select mx-2"
                    v-model="pagination.perPage"
                    placeholder="Per page"
                >
                    <el-option
                        class="select-primary"
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                    >
                    </el-option>
                </el-select>
    
            </div>
            <base-pagination
                class="pagination-no-border"
                :current="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                @change="paginationChanged($event)"
            >
            </base-pagination>
        </div>
        <PreviewModal ref="preview_modal"></PreviewModal>
    </b-card>
</template>
<script>
import { Table, TableColumn, Dropdown, DropdownItem, DropdownMenu, Select, Option } from 'element-ui'
import { BasePagination } from '@/components'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'
import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
} from '@/assets/js/httpImports.js'
import { mapActions, mapState } from 'pinia'
import { useAuthStore } from '@/stores/authStore'
import { useCustomerStore } from '@/stores/customerStore'
import { useConfigStore } from '@/stores/configStore'
import PreviewModal  from '@/components/Modal/PreviewModal'

export default {
    mixins: [notifyFunctionMixin,clientPaginationMixin],
    components: {
        PreviewModal,
        BasePagination,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
            isTableLoading: false,
            propsToSearch: ['credit_report_cust_name', 'credit_report_id', 'credit_report_cust_ic', 'credit_report_cust_id'],
            mode: 'listing',
            currentPage: 1,
            selectedRows: [],
            searchText: '',
            debouncedHandler: '',
            TableColumn:[{
                type: 'selection'
            }],
            tableData: [],
            pagination: {
							perPageOptions: [5, 10, 25, 50, 100, 500],
							currentPage: 1,
							perPage: 25,
							total: 0,
							from: null,
							to: null
						},
        }
    },
    created() {
        this.getCreditReportsList()
    },
    computed:{
        ...mapState(useAuthStore, ['viewable_customer_ids']),
        ...mapState(useConfigStore, ['app_code']),
    },
    mounted() {
        this.debouncedHandler = debounce(() => {
        }, 500);
    },
    methods: {
        ...mapActions(useCustomerStore, ['getCustomerCount']),
        selectionChange(selectedRows) {
            this.selectedRows = selectedRows
        },
        paginationChanged(page)
        {
          this.pagination.currentPage = page
					this.getCreditReportsList();
        },
        async getCreditReportsList() {
            this.isTableLoading = true

						let queryParams = _gHlp.generateQueryParams({
							paginate:this.pagination.perPage,
							page:this.pagination.currentPage,
							orderBy:{
								credit_report_id:'desc'
							},
							search:{
								credit_report_status:'completed',	
								credit_report_application_code:this.app_code,	
							}
						})

            const url = `${services.commitment}credit-reports?${queryParams}`
            axios.get(url, {headers: getHeader()})
            .then(res => {
                this.tableData = res.data.data
								this.pagination = _gHlp.setPaginate(res.data.meta)
								this.isTableLoading = false
            }).catch(e => {
								this.is_loading = false
                this.errorFunction(e)
            })
        }
    }
}
</script>